import React from 'react'
import Helmet from 'react-helmet'
import icon from '@assets/favicon.ico'
import ogImg from '@assets/img/opengraph.jpg'

type HeadProps = {
  title?: string,
  description?: string,
  ogDescription?: string,
  path: string,
  schema?: object
}

const URL = 'https://www.wecharge.com.br'

export default ({ title, description, ogDescription, path, schema }: HeadProps) => <Helmet htmlAttributes={{ lang : 'pt-BR' }}>
  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
  <meta name="d4sign-domain-verification" content="47683f0a-1649-4ee4-b372-dbcb8dc296ad" />
  <meta property="og:image" itemProp="image" content={URL + ogImg} />
  <meta name="twitter:image" content={URL + ogImg} />
  <title>{title || 'WeCharge: rede de eletropostos e mobilidade elétrica'}</title>
  <meta charSet="utf-8" />
  <meta name="description" content={description || 'Procurando eletropostos? Carregue seu carro elétrico ou híbrido, independente da marca e modelo, de forma confiável, de qualidade e com energia limpa.'} />
  <meta name="keywords" content="carregamento carro elétrico, carregamento carro híbrido, recarga carro elétrico, recarga carro híbrido, eletropostos, carro elétrico, abastecimento elétrico, carregador elétrico empresarial, carregador elétrico doméstico, wallbox"></meta>
  <meta property="og:title" content={title || 'WeCharge: rede de eletropostos e mobilidade elétrica'} />
  <meta property="og:site_name" content="Wecharge" />
  <meta property="og:description" content={ogDescription || description || 'Carregue seu carro elétrico ou híbrido, independente da marca e modelo, de forma confiável, de qualidade e com energia limpa.'} />
  <meta property="og:url" content={URL + path} />
  <meta property="og:locale" content="pt_BR" />
  <link rel="canonical" href={URL + path} />
  <link rel="icon" type="image/x-icon" href={URL + icon} />
  {schema && <script type="application/ld+json">{JSON.stringify(schema).replace(/</g, '\\u003c')}</script>}
</Helmet>